<template>
    <div class="form-group">
        <label for="">
            <span class="label-title">{{field.label}}</span>
            <span v-if="field.required" class="required-field">*</span>
        </label>
        <div class="input-group date" data-target-input="nearest">
            <input :value="field.value" type="text" class="form-control datetimepicker-input" autocomplete="off" data-toggle="datetimepicker" :id="field.name" :data-target="`#${field.name}`" />
            <div class="input-group-append" data-toggle="datetimepicker" :data-target="`#${field.name}`">
                <div class="input-group-text"><i class="fa fa-calendar"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
global.moment = require('moment');
require('tempusdominus-bootstrap-4');

const events = ['hide', 'show', 'change', 'error', 'update'];
const eventNameSpace = 'datetimepicker';

export default {
    name: 'date-time-picker',
    props: {
        FieldData: {
            type: Object,
            required: false
        },
        wrap: {
            type: Boolean,
            default: false
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD'
        }
    },
    data() {
        return {
            dp: null,
            configData: {
                format: this.format,
            },
            defaultConfigData: {
                format: 'YYYY-MM-DD',
            },
            elem: null,
            field: this.FieldData
        }
    },
    mounted() {
        if (this.dp) return;

        moment.tz.setDefault('Etc/UTC');

        this.elem = jQuery(this.wrap ? this.$el.parentNode: this.$el);

        if (this.format) {
            this.configData.format = this.format;
        } else {
            this.configData = this.defaultConfigData;
        }

        this.configData.useCurrent = false;

        this.elem.datetimepicker(this.configData);

        if(this.FieldData.value != null || this.FieldData.value != undefined){
            this.elem[0].value = this.FieldData.value;
        }

        this.dp = this.elem.data('datetimepicker');

        this.elem.on('change.datetimepicker', this.onChange);
        this.registerEvents();
    },
    watch: {
        value(newValue) {
            this.dp && this.dp.date(newValue || null)
        },
    },
    beforeDestroy: function() {
        if(this.dp) {
            this.dp.destroy();
            this.dp = null;
            this.elem = null;
        }
    },
    methods: {
        onChange(event) {
            let formattedDate = event.date ? event.date.format(this.dp.format()) : null;
            this.$emit('input', formattedDate);
        },
        registerEvents() {
            events.forEach((name) => {
                this.elem.on(`${name}.${eventNameSpace}`, (...args) => {
                    this.$emit(`on-${name}`, ...args);
                });
            })
        }
    }
}
</script>
<style scoped lang="scss">
    .input-group-append{
        .input-group-text{
            background-color: #fff;
        }
    }
</style>